// oxlint-disable-next-line no-restricted-imports
import Decimal from 'decimal.js';

// Any value that could reach `decimal.js` from a form field, API response,
// or MobX observable. Form fields emit empty strings while typing, and API
// responses may omit numeric fields — `new Decimal('')` / `new Decimal(null)`
// throw synchronously during render (see TRE-14240).
type DecimalInput = Decimal.Value | null | undefined | '';

export const toDecimal = (value: DecimalInput): Decimal =>
  new Decimal(value === '' || value === null || value === undefined ? 0 : value);
